import { agent } from '../utils/agent'

const API_URL = process.env.REACT_APP_API_URL

/**
 * Platform Analytics — the super admin's cross-game view, served by
 * /platform-analytics/* (PlatformAnalyticsController). Super admin only; the
 * API answers 403 for anyone else.
 *
 * Days are counted on the viewer's own clock, so every request carries the
 * browser's IANA timezone as `tz`.
 */
const viewerTimezone = () => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC'
  } catch (e) {
    return 'UTC'
  }
}

const buildParams = (filters = {}, extra = {}) => {
  const params = new URLSearchParams()
  if (filters.from) params.set('from', filters.from)
  if (filters.to) params.set('to', filters.to)
  if (filters.platform && filters.platform !== 'all') params.set('platform', filters.platform)
  params.set('tz', viewerTimezone())
  Object.entries(extra).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') params.set(key, value)
  })
  return params.toString()
}

const get = async (path, filters, extra) => {
  const response = await agent.get(
    `${API_URL}platform-analytics/${path}?${buildParams(filters, extra)}`,
  )
  return response.data
}

const PlatformAnalyticsService = {
  viewerTimezone,
  getOverview: (filters) => get('overview', filters),
  getTrends: (filters, interval = 'day') => get('trends', filters, { interval }),
  getGames: (filters) => get('games', filters),
  getUsage: (filters) => get('usage', filters),
  getGame: (filters, gameId) => get(`game/${gameId}`, filters),
  getLive: () => get('live', {}),
  /** params: { page, limit, game_id, search, online: '1', sort, order } */
  getUsers: (filters, params) => get('users', filters, params),
  getUser: (filters, userId) => get(`user/${userId}`, filters),
  getScreenGames: (filters, pageName) => get('screen-games', filters, { page_name: pageName }),
}

export default PlatformAnalyticsService
